<template>
  <div class="l-container--width-90">
    <v-overlay :model-value="showOverlay">
      <v-progress-circular color="background" indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-runtime-template :template="learnMoreHTML"></v-runtime-template>
  </div>
</template>

<script>
import ConfigImage from './ConfigImage.vue';
import DetectionCategoryCarousel from './DetectionCategoryCarousel.vue';
import Resources from '../Resources.vue';
import VRuntimeTemplate from 'vue3-runtime-template';
import { useRoute } from 'vue-router';

export default {
  name: 'LearnMore',
  components: {
    ConfigImage, // eslint-disable-line
    DetectionCategoryCarousel, // eslint-disable-line
    Resources, // eslint-disable-line
    VRuntimeTemplate,
  },
  data: () => ({
    learnMoreHTML: ``,
    showOverlay: true,
    route: useRoute(),
  }),
  watch: {
    'route.path': function() {
      // Edge case if user navigates between two different learn more pages
      this.route.params.templateType && this.getLearnMore();
    },
  },
  methods: {
    getLearnMore: function() {
      let adversary = this.route.params.adversary;
      let domain = this.route.params.domain;
      let templateType = this.route.params.templateType;

      this.$api
        .get(`templates/?adversary=${adversary}&domain=${domain}&template_type=${templateType}`)
        .then((response) => {
          if (!response.data.length) this.$handleNotFound();

          this.learnMoreHTML = `${response.data[0].template}`;
          this.showOverlay = false;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  beforeMount() {
    this.getLearnMore();
  },
};
</script>

<style lang="scss">
  @import "../../sass/pages/_learn-more.scss";
</style>